import { ThemeProvider } from "./ThemeContext";
import { LocalRoutesProvider } from "./RoutesContext";

//uniq provider for multiple context
const AppContextProvider = ({ children }) => {
  return (
    <LocalRoutesProvider>
      <ThemeProvider>{children}</ThemeProvider>
    </LocalRoutesProvider>
  );
};

export default AppContextProvider;
